module.exports = __webpack_public_path__ + "static/img/tab-one-active.9aae9e25.png";